export default class SalaryClassActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static BEFORE_VIEW='BEFORE_VIEW';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_SALARYCLASS='GET_HELPER_SALARYCLASS';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: SalaryClassActions.ON_SUBMIT
    };
  }
  static beforeView(){
    return {
      type: SalaryClassActions.BEFORE_VIEW,
    };
  }
  static create(data) {
    return {
      type: SalaryClassActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: SalaryClassActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: SalaryClassActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: SalaryClassActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: SalaryClassActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: SalaryClassActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: SalaryClassActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: SalaryClassActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: SalaryClassActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: SalaryClassActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: SalaryClassActions.GET_HELPER_SALARYCLASS,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: SalaryClassActions.ERROR_SERVER,
      payload: error
    };
  }
}